import React from 'react';
import { Building2Icon, RocketIcon, ScaleIcon, TrendingUpIcon } from 'lucide-react';
import type { PartnerAudience, PartnerProfile } from '../../../types/partners';
import { Reveal } from '../../ui/Reveal';
const ICONS: Record<PartnerAudience['icon'], typeof RocketIcon> = {
  investors: TrendingUpIcon,
  founders: RocketIcon,
  corporate: Building2Icon,
  advisors: ScaleIcon
};
export function PartnerContextSection({
  context
}: {
  context: NonNullable<PartnerProfile['context']>;
}) {
  return <section aria-labelledby="partner-context-heading" className="border-b border-hairline-soft bg-surface" data-id="element-592" data-mp="2a0y53zr3z34f">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-593" data-mp="2o0fuohc8akeu">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16" data-id="element-594" data-mp="2j0tkkgrp5ka9">
          <Reveal data-id="element-595" data-mp="tln44wq7cjtr">
            <p className="text-[11px] font-semibold uppercase tracking-[0.09em] text-[color:var(--pa)]" data-id="element-596" data-mp="tn7x4hwvbupi">{context.eyebrow}</p>
            <h2 id="partner-context-heading" className="sf-display mt-4 text-balance text-[32px] leading-[1.04] text-text-primary sm:text-[44px]" data-id="element-597" data-mp="oowoubm81s9e">
              {context.headline}
            </h2>
          </Reveal>
          <Reveal delay={0.05} className="flex flex-col gap-4" data-id="element-598" data-mp="33suthg6uxupc">
            {context.body.map(paragraph => <p key={paragraph} className="text-[15px] leading-relaxed text-text-secondary sm:text-base" data-id="element-599" data-mp="3cn9bhqirvjc5">
                {paragraph}
              </p>)}
            {context.facts?.length ? <div className="mt-2 rounded-2xl border border-hairline bg-panel p-5" data-id="element-600" data-mp="3ml6wm55c500j">
                <p className="text-[11px] font-semibold uppercase tracking-[0.09em] text-text-tertiary" data-id="element-601" data-mp="3rkjv5n5kjviy">{context.factsLabel}</p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-602" data-mp="3vmn527clas24">
                  {context.facts.map(fact => <li key={fact} className="flex items-start gap-2 text-sm text-text-primary" data-id="element-603" data-mp="1x7k673fatoz0">
                      <span aria-hidden="true" className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[color:var(--pa)]" data-id="element-604" data-mp="2195gch0g7p5i" />
                      {fact}
                    </li>)}
                </ul>
              </div> : null}
          </Reveal>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-605" data-mp="3djy9f3uboka9">
          {context.audiences.map((audience, index) => {
          const Icon = ICONS[audience.icon];
          return <Reveal key={audience.title} as="li" delay={index * 0.05} className="rounded-2xl border border-hairline bg-panel p-6 transition-shadow hover:shadow-md" data-id="element-606" data-mp="3nh404az0y99y" data-mpi={index}>
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--pa-soft)] text-[color:var(--pa)]" data-id="element-607" data-mp="12b5vjipy3bi">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-608" data-mp="3s9ng1el6pghx" />
                </span>
                <h3 className="mt-5 text-base font-semibold tracking-[-0.015em] text-text-primary" data-id="element-609" data-mp="a27r1b5wgk1t">{audience.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-text-secondary" data-id="element-610" data-mp="557hurdr716h">{audience.body}</p>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}